export class Action {
  constructor(
    public title: string,
    public fn: () => unknown
  ) {}
}
